import { RootState } from '..';

const getUserId = (state: RootState) => {
  return state.user.userId;
};

export {
  getUserId,
}
